import React from "react";
import Button from "../shared/Button/Button";

interface CustomImageProps {
  src: string;
  alt: string;
  customClassName?: string;
}

interface HeaderButtonComponentProps {
  buttonText?: any;
  children?: JSX.Element;
  leftIcon?: CustomImageProps;
  rightIcon?: CustomImageProps;
  onClick: () => void;
  customCSS?: string;
  isRedButton?: boolean;
  customButtonHeight?: string;
  customButtonRadius?: string;
  loading?:boolean;
}

const HeaderButtonComponent: React.FC<HeaderButtonComponentProps> = ({
  buttonText = "button",
  children,
  leftIcon,
  rightIcon,
  onClick,
  customCSS,
  isRedButton = false,
  customButtonHeight,
  customButtonRadius,
  loading
}) => {
  return (
    <Button
      className={`flex items-center p-[7px_12px] md:p-[7px_18px] text-[10px] font-[500] justify-center gap-1 text-white
        ${
        isRedButton ? " bg-custom-red-gradient " : "bg-blue4 active:bg-blue5"
      } ${customCSS} ${customButtonHeight} ${
        customButtonRadius || "rounded-[5px]"
      }`}
      onClick={onClick}
      loading={loading}
    >
      {leftIcon && (
        <img
          src={leftIcon.src}
          alt={leftIcon.alt}
          className={leftIcon.customClassName || "h-3.5 w-3.5"}
        />
      )}
      {children ? (
        children
      ) : (
        <span className="text-sm md:text-xs text-white font-bold">
          {buttonText}
        </span>
      )}
      {rightIcon && (
        <img
          src={rightIcon.src}
          alt={rightIcon.alt}
          className={rightIcon.customClassName || "h-2.7 w-2.7 "}
        />
      )}
    </Button>
  );
};

export default HeaderButtonComponent;
